import images from "./images";

const testimonials = [
  {
    id: 1,
    image: images.testimonial1,
    name: "Richard Ellison",
    title: "Customer",
    content: "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Debitis in ea expedita libero error aut itaque quia praesentium? Consectetur nam, maxime atque sit eius corporis voluptate? Exercitationem dolorem consequatur voluptatibus?",
  },
  {
    id: 2,
    image: images.testimonial2,
    name: "Claire Whichcord",
    title: "Customer",
    content: "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Debitis in ea expedita libero error aut itaque quia praesentium? Consectetur nam, maxime atque sit eius corporis voluptate? Exercitationem dolorem consequatur voluptatibus?",
  },
  {
    id: 3,
    image: images.testimonial3,
    name: "Kim Barnett",
    title: "Customer",
    content: "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Debitis in ea expedita libero error aut itaque quia praesentium? Consectetur nam, maxime atque sit eius corporis voluptate? Exercitationem dolorem consequatur voluptatibus?",
  },
  {
    id: 4,
    image: images.testimonial4,
    name: "Linda Burnley",
    title: "Customer",
    content: "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Debitis in ea expedita libero error aut itaque quia praesentium? Consectetur nam, maxime atque sit eius corporis voluptate? Exercitationem dolorem consequatur voluptatibus?",
  },
];

export default testimonials;